import React from "react";
import { Facebook, Instagram, MapPin, Phone, Clock } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-forest-dark text-cream/85 py-14 md:py-16"
    >
      <div className="container-narrow">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="inline-flex items-center justify-center w-9 h-9 rounded-md bg-mustard text-forest font-heading font-bold text-lg">
                JK
              </span>
              {/* TODO: uzupełnić przez klienta */}
              <span className="font-heading font-semibold text-cream text-lg">
                Jan Kowalski · Ubezpieczenia
              </span>
            </div>
            <p className="text-cream/70 text-sm leading-relaxed max-w-sm">
              Lokalny agent ubezpieczeniowy działający od 13 lat w Bieszczadach
              i na Podkarpaciu. 100% klientów z polecenia.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-cream mb-4 text-base">Kontakt</h4>
            <ul className="space-y-2.5 text-sm text-cream/75">
              <li className="flex items-center gap-1.5">
                <Phone size={14} /> +48 669 255 184
              </li>
              <li>kontakt@agentbieszczady.pl</li>
              <li className="flex items-start gap-1.5">
                <MapPin size={14} className="mt-0.5 flex-shrink-0" />
                <span>plac Konstytucji 3 Maja 7<br />38-600 Lesko</span>
              </li>
              <li className="flex items-start gap-1.5">
                <Clock size={14} className="mt-0.5 flex-shrink-0" />
                <span>Pon. – Pt., 8:00 – 16:00</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-cream mb-4 text-base">Znajdź mnie</h4>
            <div className="flex gap-3">
              {/* TODO: uzupełnić linkami do realnych profili */}
              <a
                href="#"
                data-testid="footer-facebook"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full bg-cream/10 hover:bg-mustard hover:text-forest flex items-center justify-center transition-colors"
              >
                <Facebook size={18} />
              </a>
              <a
                href="#"
                data-testid="footer-instagram"
                aria-label="Instagram"
                className="w-10 h-10 rounded-full bg-cream/10 hover:bg-mustard hover:text-forest flex items-center justify-center transition-colors"
              >
                <Instagram size={18} />
              </a>
            </div>
            <div className="mt-6">
              {/* TODO: uzupełnić linkami do regulaminu / polityki prywatności */}
              <a
                href="#"
                className="block text-sm text-cream/70 hover:text-mustard transition-colors"
                data-testid="footer-privacy-link"
              >
                Polityka prywatności
              </a>
              <a
                href="/admin/login"
                className="block text-sm text-cream/50 hover:text-mustard transition-colors mt-1"
                data-testid="footer-admin-link"
              >
                Panel agenta
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-cream/10 text-sm text-cream/55 flex flex-col sm:flex-row justify-between gap-2">
          <div>© {new Date().getFullYear()} Jan Kowalski · Ubezpieczenia. Wszystkie prawa zastrzeżone.</div>
          <div>Bieszczady · Podkarpacie</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
